var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('router-link',{attrs:{"to":_vm.link}},[_vm._v(" "+_vm._s(_vm.username || _vm.content))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }